import { setCurrectChat } from "../../../../redux/admin-slices/socket.slice";
import { Avatar, Box, IconButton, ListItemText } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import Icons from "../../../../assets/js/Icons";
import moment from "moment";

function Header() {
  const dispatch = useDispatch();
  const { chat } = useSelector((state) => state.socketSlice);

  return (
    <Box
      sx={{
        p: 1,
        gap: 1,
        display: "flex",
        alignItems: "center"
      }}
    >
      <Avatar
        sx={{ width: 40, height: 40 }}
        src={chat?.user?.image}
      />
      <ListItemText
        sx={{ m: 0 }}
        primary={chat?.user?.fullName || "Unknown user"}
        // secondary={moment().format("hh:mm A") + " — Local time"}
        slotProps={{
          primary: { sx: { fontWeight: "500", lineHeight: 1.2, textTransform: "capitalize" } },
          secondary: { sx: { fontSize: 13, lineHeight: 1, mt: 0.5 } },
        }}
      />
      <IconButton
        size="small"
        sx={{ ml: "auto" }}
        onClick={() => { dispatch(setCurrectChat({})) }}
      ><Icons.CancelSolid />
      </IconButton>
    </Box>
  )
}

export default Header